import styled from "styled-components";

export const StyledStoreOverView = styled.div`
  .header {
    font-size: 18px;
    line-height: 22px;
    font-weight: 300;
    color: var(--gray);
    margin-bottom: 20px;
  }
`;
export const OverviewWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  @media (min-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }
  gap: 20px;
  margin-bottom: 20px;
  /* & > :last-child {
    grid-column: span 2;
  } */
`;

export const SalesWrapper = styled.div`
  padding: 15px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
  border-radius: 15px;
  .sale-chart {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    @media (min-width: 991px) {
      grid-template-columns: repeat(2, 1fr);
    }
    align-items: center;
    gap: 20px;
    .chart > div {
      width: 100% !important;
      height: 150px !important;
      @media (min-width: 991px) {
        height: 200px !important;
      }
    }
  }
  .title {
    display: block;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--gray-line, #ececec);
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    padding-bottom: 5px;
  }
  .sales-info {
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      font-size: 16px;
      line-height: 20px;
      font-weight: 300;
      @media (min-width: 991px) {
        font-size: 18px;
        line-height: 22px;
        margin-bottom: 10px;
      }
      span{
        font-size: 16px; 
        line-height: 20px;
      }
      span:first-child::before {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: currentColor;
        display: inline-block;
        margin-right: 8px;
      }
    }
  }
`;
export const MenuWrapper = styled.div`
  padding: 15px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
  border-radius: 15px;
  .title {
    display: block;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--gray-line, #ececec);
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    padding-bottom: 5px;
  }
  .menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    font-weight: 400;
    gap: 20px;
    color: var(--gray);
    span {
      flex: 1;
      text-align: left;
    }
  }
  .menu-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #edf2f6;
    gap: 20px;
    .item-info {
      display: flex;
      align-items: center;
      flex: 1;
      .item-image {
        width: 30px;
        height: 30px;
        margin-right: 10px;
        border-radius: 5px;
      }
      span {
        font-weight: 400;
      }
    }
    .item-price,
    .item-id {
      flex: 1;
      text-align: left;
      font-weight: 400;
    }
  }
`;
export const ReviewWrap = styled.div`
  padding: 15px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.11);
  border-radius: 15px;
  margin-bottom: 30px;
`;
